import React from "react";
import loadable from "@loadable/component";
import { Container } from "@atoms";

const ContentBuilder = loadable(() => import("@organisms/ContentBuilder"));
const HeroPage = loadable(() => import("@organisms/HeroPage"));
const Sidebar = loadable(() => import("@organisms/Sidebar"));

const PagePage = ({ data, defaults }) => {
  const { hero, contentBuilder, sidebar } = data;
  return (
    <>
      <HeroPage {...hero} />
      <div className="relative z-10 pt-10">
        <Container>
          <div className="flex justify-center gap-10">
            <div className="w-full md:w-3/5">
              <ContentBuilder blocks={contentBuilder} />
            </div>
            {sidebar && (
              <div className="w-full md:w-2/3">
                <Sidebar {...sidebar} defaults={defaults} />
              </div>
            )}
          </div>
        </Container>
      </div>
    </>
  );
};

PagePage.defaultProps = {};

export default PagePage;
